import { Box, makeStyles, Typography } from '@material-ui/core';
import { activeChatSelector } from '@src/selectors/chats';
import type { RootState } from '@src/store/reduxstore';
import { FormattedMessage, useIntl } from 'react-intl';
import { useSelector } from 'react-redux';

const ServiceWindowExpiredMessage: React.FC = () => {
  const { formatMessage } = useIntl();
  const { container, text, bold } = useStyles();
  const activeChat = useSelector(activeChatSelector);
  const isExpired = useSelector(
    (state: RootState) =>
      !!state.chats?.serviceWindowExpiredChatIds?.[activeChat?.id]
  );

  if (!isExpired) return null;

  return (
    <Box className={container} padding="8px 8px 0 8px">
      <svg
        width="19"
        height="16"
        viewBox="0 0 19 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M0 15.8333L9.16667 0L18.3333 15.8333H0ZM2.875 14.1667H15.4583L9.16667 3.33333L2.875 14.1667ZM9.16667 13.3333C9.40278 13.3333 9.60069 13.2535 9.76042 13.0937C9.92014 12.934 10 12.7361 10 12.5C10 12.2639 9.92014 12.066 9.76042 11.9062C9.60069 11.7465 9.40278 11.6667 9.16667 11.6667C8.93056 11.6667 8.73264 11.7465 8.57292 11.9062C8.41319 12.066 8.33333 12.2639 8.33333 12.5C8.33333 12.7361 8.41319 12.934 8.57292 13.0937C8.73264 13.2535 8.93056 13.3333 9.16667 13.3333ZM8.33333 10.8333H10V6.66667H8.33333V10.8333Z"
          fill="currentColor"
        />
      </svg>
      <Typography className={text} component="span">
        <FormattedMessage
          id="ChatMessageComposer.serviceWindowExpired.text"
          values={{
            buttonName: (
              <span className={bold}>
                {formatMessage({ id: 'AgentToolbar.resumeButton.label' })}
              </span>
            ),
          }}
        />
      </Typography>
    </Box>
  );
};

export default ServiceWindowExpiredMessage;

const useStyles = makeStyles(theme => ({
  container: {
    display: 'flex',
    alignItems: 'center',
    backgroundColor: theme.palette.grey[100],
    color: theme.b2chatorange[600],
    gap: 8,
  },
  text: {
    fontWeight: 400,
    fontSize: '0.9rem',
  },
  bold: {
    fontWeight: 700,
  },
}));
